import {BBElement} from "../forms/elements/BBElement";

import {InputType} from './normolizer/InputType';
import {TypeDate} from './normolizer/types/Date';
import {TypeNumber} from './normolizer/types/Number';
import {TypeDecimal} from './normolizer/types/Decimal';
import {TypeTel} from './normolizer/types/Tel';
import {TypeEmail} from './normolizer/types/Email';
import {TypeSearch} from './normolizer/types/Search';
import {TypeAutocomplete} from './normolizer/types/Autocomplete';
import {TypeSelect} from './normolizer/types/TypeSelect';
import {TypeAnchorsScroll} from './normolizer/types/AnchorsScroll';

import {InputMask} from './normolizer/InputMask';
import {MaskCard} from './normolizer/masks/Card';
import {MaskDateDM} from './normolizer/masks/DateDM';
import {MaskNumber} from './normolizer/masks/Number';
import {MaskPaySum} from './normolizer/masks/PaySum';
import {MaskMobileNumberRus} from './normolizer/masks/MobileNumberRus';
import {MaskSeriesNumber} from './normolizer/masks/SeriesNumber';
import {MaskSnils} from './normolizer/masks/Snils';
import {MaskDateRu} from './normolizer/masks/DateRu';
import {MaskSubDivCode} from './normolizer/masks/SubDivCode';
import {MaskINN} from './normolizer/masks/INN';
import {MaskLimitCreditCard} from './normolizer/masks/LimitCreditCard';
import {MaskPaspSeria} from './normolizer/masks/PaspSeria';
import {MaskPaspNumber} from './normolizer/masks/PaspNumber';
import {MaskMobilePrefixNumberRus} from './normolizer/masks/MobilePrefixNumberRus';

export class Normolizer {

    constructor() {
        this.init();
    }

    public init() {
        // тип полей (преобразование в html5)
        this.initInput('bb_type_number', TypeNumber, InputType);
        this.initInput('bb_type_decimal', TypeDecimal, InputType);
        this.initInput('bb_type_date', TypeDate, InputType);
        this.initInput('bb_type_tel', TypeTel, InputType);
        this.initInput('bb_type_email', TypeEmail, InputType);
        this.initInput('bb_type_search', TypeSearch, InputType);
        this.initInput('bb_type_autocomplete', TypeAutocomplete, InputType);
        this.initInput('bb_type_select', TypeSelect, InputType);
        this.initInput('bb_type_anchors_scroll', TypeAnchorsScroll, InputType);
        // маски
        this.initInput('bb_mask_card', MaskCard, InputMask);
        this.initInput('bb_mask_date_dm', MaskDateDM, InputMask);
        this.initInput('bb_mask_number', MaskNumber, InputMask);
        this.initInput('bb_mask_paysum', MaskPaySum, InputMask);
        this.initInput('bb_mask_mobilerus', MaskMobileNumberRus, InputMask);
        this.initInput('bb_mask_seriesnumber', MaskSeriesNumber, InputMask);
        this.initInput('bb_mask_snils', MaskSnils, InputMask);
        this.initInput('bb_mask_dateru', MaskDateRu, InputMask);
        this.initInput('bb_mask_subdivcode', MaskSubDivCode, InputMask);
        this.initInput('bb_mask_inn', MaskINN, InputMask);
        this.initInput('bb_mask_limitcreditcard', MaskLimitCreditCard, InputMask);
        this.initInput('bb_mask_paspseria', MaskPaspSeria, InputMask);
        this.initInput('bb_mask_paspnumber', MaskPaspNumber, InputMask);
        this.initInput('bb_mask_mobilerusprefix', MaskMobilePrefixNumberRus, InputMask);
    }


    private initInput(className: string, useCase: any, input: any) {
        let fields = document.querySelectorAll('.' + className);
        for (let i = 0; i < fields.length; i++) {
            let field = (fields[i] as HTMLInputElement);
            let bbfield = new BBElement(field);
            bbfield.removeClass(className);
            let normolizer = new input(new useCase());
            normolizer.setTarget(field);
            normolizer.execute();
        }
    }
}
